"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserStore = void 0;
class UserStore {
    data;
    constructor() {
        this.data = {};
    }
    add(u) {
        return this.data[u.getId()] = u;
    }
    byId(id) {
        return this.data[id];
    }
    query(options) {
        return Object.values(this.data).filter(u => {
            if (options.id && u.getId() !== options.id) {
                return false;
            }
            return true;
        });
    }
    delete(id) {
        new Error("not implemented");
    }
}
exports.UserStore = UserStore;
